import styled from 'styled-components';

const Container = styled.div``;

const Category = styled.div`
  margin-bottom: 40px;
`;

const CategoryTitle = styled.div`
  margin-bottom: 9px;
  font-weight: bold;
  font-size: 14px;
  color: var(--text-color-3);

  svg {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    position: relative;
    top: 5px;
    right: 3px;
  }
`;

const SearchConditions = styled.div``;

const Item = styled.div`
  display: flex;
`;

const Title = styled.div`
  padding-top: 5px;
  width: 38%;

  span {
    color: var(--text-color-3);
    width: 40px;
    display: inline-block;
  }
`;

const TagBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 62%;
`;

const TagItem = styled.span`
  margin: 0 5px 6px 0;
  padding: 5px 10px;
  background: #f3f5f7;
  border-radius: 4px;
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-1);

  svg {
    margin-right: 6px;
  }
`;

export {
  Container,
  Category,
  CategoryTitle,
  SearchConditions,
  Item,
  Title,
  TagBox,
  TagItem,
};
